import script from "./ColourSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColourSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ColourSelector.vue?vue&type=style&index=0&id=5c5b2196&lang=scss"

const __exports__ = script;

export default __exports__